module.exports = __webpack_public_path__ + "images/e_signatures/certified_stamp.png";